// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1029) return "static/chunks/1029-8a61047b3669fedb.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"2084":"02c5544688382fb5","5547":"c35c4946f1298ada","8162":"6f39310d60773f80"}[chunkId] + ".js";
};